import { NgModule } from '@angular/core';
import { CkEditorFetchWebPageContentPluginService } from './service/ck-editor-fetch-web-page-content-plugin.service';
import { FetchWebPageContentDialogComponent } from './fetch-web-page-content-dialog.component';
import { DialogModule } from '../dialogs/dialogs.module';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { CommonDirectivesModule } from '../directives/common-directives.module';
import { TranslateModule } from '@ngx-translate/core';
import { WebPageContentApi } from './web-page-content.api';

@NgModule({
  imports: [CommonModule, FormsModule, DialogModule, CommonDirectivesModule, TranslateModule.forChild()],
  declarations: [FetchWebPageContentDialogComponent],
  entryComponents: [FetchWebPageContentDialogComponent],
  providers: [
    CkEditorFetchWebPageContentPluginService, WebPageContentApi
  ]
})
export class CkEditorFetchWebPageContentPluginModule {}
